import api from "@/utils/http";

export * from './type'
export * from './audit_type'
export * from './log'

/**
 功能：
 time: 2026/3/9 11:52
 **/
export function getProjectList(data) {
    return api.post('/partner/project/getList', data)
}

/**
 功能：
 time: 2026/3/9 12:12
 **/
export function getProjectShow(project_id) {
    return api.post('/partner/project/getShow', {project_id })
}

/**
 功能：
 time: 2025-51-03 14:51:23
 **/
export function getProjectConfig() {
    return api.get('/admin/project/getSetConfig')
}
/**
 功能：
 time: 2025/12/16 11:02
 **/
export function getProjectSelectList() {
    return api.get('/admin/project/getSearchList')
}


/**
 功能：保存
 time: 2025-38-02 16:38:38
 **/
export function saveProject(data) {
    return api.post('/admin/project/eSave', data)
}
/**
 功能：查询立项列表
 time: 2025/12/19 18:03
 **/
export function getProjectInitList(data) {
    return api.post('/admin/project/getInitList', data)
}
/**
 功能：立项审批
 time: 2025/12/20 09:26
 **/
export function initExamine(data) {
    return api.post('/admin/project/initExamine', data)
}
/**
 功能：项目报价列表
 time: 2025/12/19 18:03
 **/
export function getProjectQuoteList(data) {
    return api.post('/admin/project/getQuoteList', data)
}
/**
 功能：项目报价
 time: 2025/12/20 09:26
 **/
export function quoteProject(data) {
    return api.post('/admin/project/quoteSave', data)
}
/**
 功能：项目报价审批
 time: 2025/12/20 11:08
 **/
export function quoteExamine(data) {
    return api.post('/admin/project/quoteExamine', data)
}
/**
 功能：合同签署列表
 time: 2025/12/19 18:03
 **/
export function getProjectContractList(data) {
    return api.post('/admin/project/getContractList', data)
}
/**
 功能：合同签署
 time: 2025/12/20 09:26
 **/
export function contractProject(data) {
    return api.post('/admin/project/contractSave', data)
}

/**
 功能：确认开始施工
 time: 2025/12/22 09:41
 **/
export function workTrueProject(data) {
    return api.post('/admin/project/workTrueSave', data)
}

/**
 功能：项目完工
 time: 2025/12/27 14:19
 **/
export function workCompletedProject(data) {
    return api.post('/admin/project/workCompletedSave', data)
}

/**
 功能：项目验收
 time: 2025/12/27 15:01
 **/
export function workAcceptanceProject(data) {
    return api.post('/admin/project/workAcceptanceSave', data)
}
/**
 功能：审计
 time: 2026/1/4 09:51
 **/
export function auditProject(data) {
    return api.post('/admin/project/auditSave', data)
}
/**
 功能：施工项目列表
 time: 2025/12/22 10:18
 **/
export function getProjectWorkList(data) {
    return api.post('/admin/project/getWorkList', data)
}

/**
 功能：维保和尾款列表
 time: 2026/1/4 09:05
 **/
export function getProjectProtectList(data) {
    return api.post('/admin/project/getProtectList', data)
}

/**
 功能：完结项目列表
 time: 2026/1/4 14:25
 **/
export function getProjectSuccessList(data) {
    return api.post('/admin/project/getSuccessList', data)
}


/**
 功能：
 time: 2026/1/4 09:51
 **/
export function workOverProject(data) {
    return api.post('/admin/project/workOverSave', data)
}

/**
 功能：编辑用
 time: 2025-42-02 16:42:10
 **/
export function getProjectDetail(project_id) {
    return api.post('/admin/project/getDetail', {project_id })
}



/**
 功能：
 time: 2026/1/6 16:42
 **/
export function getProjectCustomerId(project_id) {
    return api.post('/admin/project/getProjectCustomerId', {project_id })
}

/**
 功能：查看详情用
 time: 2025/12/19 18:06
 **/
export function getProjectContentDetail(project_id) {
    return api.post('/admin/project/getContentDetail', {project_id })
}
/**
 功能：
 time: 2025-48-03 17:48:41
 **/
export function deleteProject(project_id) {
    return api.post('/admin/project/del', {project_id})
}

/**
 功能：
 time: 2025-48-03 17:48:43
 **/
export function deleteAllProject(projectIds) {
    return api.post('/admin/project/delAll', {projectIds})
}

/**
 功能：
 time: 2026/1/5 10:22
 **/
export function setDataProject(project_id, status) {
    return api.post('/admin/project/setSaveData', {project_id, status})
}